import type { GalleryItem } from '../types/content'

// Immagini illustrative senza testo: colori vivaci e luce che attraversa
// la pittura, per mostrare bene l’effetto vetrata.
export const creations: GalleryItem[] = [
  {
    id: 'portacandele',
    motif: 'Portacandele decorativi',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/024fce6e-81b5-483e-948c-6ccf6ce05349.jpg',
    alt: 'Barattolo di vetro dipinto con effetto vetrata in rosso, blu, verde e ambra, con una candela accesa che proietta riflessi colorati sul tavolo',
  },
  {
    id: 'acchiappasole',
    motif: 'Acchiappasole',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/635bd5d3-4ecf-4aa1-bf60-8b90dfaefdec.jpg',
    alt: 'Acchiappasole rotondo a mandala floreale con effetto vetrata appeso a una finestra soleggiata, che proietta luce colorata sulla parete',
  },
  {
    id: 'specchi',
    motif: 'Specchi decorati',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/861c3a27-c130-4ce8-a63a-7df06d2e4fc9.jpg',
    alt: 'Specchio rotondo con la cornice dipinta a fiori e foglie con effetto vetrata in colori vivaci, appeso in un soggiorno luminoso',
  },
  {
    id: 'quadretti',
    motif: 'Quadretti effetto vetrata',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/6543b757-cd5d-4e03-baa2-4e1ebcb5afea.jpg',
    alt: 'Quadretto con effetto vetrata raffigurante un colibrì tra fiori tropicali, controluce davanti a una finestra',
  },
  {
    id: 'sottobicchieri',
    motif: 'Sottobicchieri personalizzati',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c7a6c026-8988-42af-ac6d-967c33150ee9.jpg',
    alt: 'Quattro sottobicchieri in vetro dipinti con fiori geometrici con effetto vetrata, che proiettano ombre colorate su una tovaglia di lino',
  },
  {
    id: 'stoviglie',
    motif: 'Stoviglie decorative',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/368ca387-dd16-4392-bc25-7a891a13ee9d.jpg',
    alt: 'Piatto e ciotola in vetro dipinti con girasoli e papaveri con effetto vetrata, su una mensola accanto a una finestra soleggiata',
  },
]
